import { SeedChartCard, useSeedingStep } from '../utilities/Setup'
import { ResetDataCard } from '../utilities/ResetData'
import { SettingsHeader, SettingsTabs } from './settingsShared'
import OnboardingStepBar from '../../components/onboarding/OnboardingStepBar'
import { useSession } from '../../session'

/** Tools that act on all of the company's data: set up the chart of
    accounts, or reset everything to start again. */
export default function DataTools() {
  // A new company setting up only needs the chart of accounts step.
  const seeding = useSeedingStep()
  // The chart is Accounting's; every plan can still reset its data.
  const { has } = useSession()
  const books = has('accounting')
  return (
    <div className="ci-page">
      <SettingsTabs />
      <OnboardingStepBar step="utilities" />
      <SettingsHeader title="Data" meta={books ? 'Set up your chart of accounts, or clear your data to start again.' : 'Clear your data to start again.'} />
      <div className="set-stack">
        {books && <SeedChartCard />}
        {(!seeding || !books) && <ResetDataCard />}
      </div>
    </div>
  )
}
